import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useTranslation } from 'react-i18next';
import '../../assets/css/cookies.css';
import { FaCookieBite } from 'react-icons/fa';

const CookiesModal = () => {
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [analyticsChecked, setAnalyticsChecked] = useState(false);
  const [marketingChecked, setMarketingChecked] = useState(false);

  useEffect(() => {
    const cookiesAccepted = getCookie('cookiesAccepted');
    if (!cookiesAccepted) {
      setShowModal(true);
      setShowOffcanvas(true);
    }
  }, []);

  const getCookie = (name) => {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + '; path=/' + expires;
  };

  const handleAcceptAll = () => {
    setCookie('cookiesAccepted', 'true', 30);
    setShowModal(false);
    setShowOffcanvas(false);
  };

  const handleFunctionalOnly = () => {
    setCookie('cookiesAccepted', 'false', 30);
    setShowModal(false);
    setShowOffcanvas(false);
  };

  const handleSavePreferences = () => {
    const preferences = {
      analytics: analyticsChecked,
      marketing: marketingChecked
    };
    setCookie('cookiePreferences', JSON.stringify(preferences), 30);
    setCookie('cookiesAccepted', 'true', 30);
    setShowModal(false);
    setShowOffcanvas(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenSettings = () => {
    // Offcanvas will be opened via data-bs-toggle
  };

  return (
    <>
      {/* Cookie Modal */}
      {showModal && (
        <div className="modal fade show" id="cookie-banner" tabIndex="-1" style={{ display: 'block' }} aria-labelledby="cookieconsentLabel2">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header btn-primary text-white">
                <h5 className="modal-title" id="cookieconsentLabel2">
                  {t('cookies.modalTitle')}
                </h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-3 d-flex align-items-center justify-content-center">
                    <FaCookieBite id="coc-icon"/>
                  </div>
                  <div className="col-9">
                    <p>
                      {t('cookies.modalDescription')}
                      <br />
                      <a href="/cookie-policy" className="cookie-text">
                        {t('cookies.cookiePolicy')}
                      </a>.
                    </p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn11"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#cookieOffcanvas"
                >
                  {t('cookies.settingsButton')}
                </button>
                <button
                  type="button"
                  className="btn2"
                  onClick={handleFunctionalOnly}
                  data-bs-dismiss="modal"
                >
                  {t('cookies.functionalOnlyButton')}
                </button>
                <button
                  type="button"
                  className="btn3"
                  onClick={handleAcceptAll}
                >
                  {t('cookies.acceptAllButton')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cookie Offcanvas */}
      {showOffcanvas && (
        <div className="cookie-offcanva bg-light" id="cookie-offcanva">
          <div className="offcanvas custom-offcanvas p-5 offcanvas-end bg-light" tabIndex="-1" id="cookieOffcanvas" aria-labelledby="cookieOffcanvasLabel">
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="cookieOffcanvasLabel">
                {t('cookies.offcanvasTitle')}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <p className="mb-5" dangerouslySetInnerHTML={{
                __html: t('cookies.offcanvasDescription')
              }}></p>

              <div className="d-flex justify-content-center flex-column align-items-center gap-4">
                <div className="form-check w-100 bg-white">
                  <h6>{t('cookies.necessaryCookies.title')}</h6>
                  <p>{t('cookies.necessaryCookies.description')}</p>
                </div>

                <div className="form-check d-flex w-100 bg-white">
                  <div className="flex-grow-1">
                    <h6>{t('cookies.analyticsCookies.title')}</h6>
                    <p>{t('cookies.analyticsCookies.description')}</p>
                  </div>
                  <input
                    type="checkbox"
                    className="form-check-input ms-3"
                    checked={analyticsChecked}
                    onChange={(e) => setAnalyticsChecked(e.target.checked)}
                  />
                </div>

                <div className="form-check d-flex w-100 bg-white">
                  <div className="flex-grow-1">
                    <h6>{t('cookies.marketingCookies.title')}</h6>
                    <p>{t('cookies.marketingCookies.description')}</p>
                  </div>
                  <input
                    type="checkbox"
                    className="form-check-input ms-3"
                    checked={marketingChecked}
                    onChange={(e) => setMarketingChecked(e.target.checked)}
                  />
                </div>
              </div>

              <div className="d-flex btn-section">
                <button
                  className="btn btn-warning mt-3 ms-auto btn3"
                  type="button"
                  onClick={handleSavePreferences}
                >
                  {t('cookies.savePreferences')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
};

export default CookiesModal;